import { jsx } from "react/jsx-runtime";
const BOLD_REGEX = /\*\*(.+?)\*\*/g;
const ITALIC_REGEX = /\*(.+?)\*/g;
const MARKDOWN_LINK_REGEX = /\[([^[]+)\](\(.*\))/gm;
const MARKDOWN_LINK_INNER_VALUES_REGEX = /\[([^[]+)\]\((.*)\)/;
function toJsx(text) {
    return /*#__PURE__*/ jsx("span", {
        dangerouslySetInnerHTML: {
            __html: text
        }
    });
}
function boldFormatter(text) {
    return text.replace(BOLD_REGEX, (_, replaced)=>`<strong class="tw-font-semibold">${replaced}</strong>`);
}
function italicFormatter(text) {
    return text.replace(ITALIC_REGEX, (_, replaced)=>`<em class="italic">${replaced}</em>`);
}
const linkFormatter = ({ text, targetBlank, className })=>text.replace(MARKDOWN_LINK_REGEX, (linkMatch)=>{
        const innerValuesMatch = MARKDOWN_LINK_INNER_VALUES_REGEX.exec(linkMatch);
        const label = innerValuesMatch ? innerValuesMatch[1] : '';
        const url = innerValuesMatch ? innerValuesMatch[2] : '';
        return `<a class="${className || 'link-level4'}" href="${url}"${targetBlank ? ' target="_blank" rel="noopener noreferrer"' : ''}>${label}</a>`;
    });
export { boldFormatter, italicFormatter, linkFormatter, toJsx };
